module.exports = __webpack_public_path__ + "static/update-data-banner-2f2c8947b6d7017caae2de9c325a5de9.png";